import { } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import FeaturesSection from "./Features";
import { motion } from 'framer-motion';
import Footer from "../../Component/Fooder";

const HealthcareProvider = () => {
    const navigate = useNavigate();

    return (
        <>
            {/* <div className="p-8  bg-gradient-to-t from-[#78ffa5] to-[#03ab3b]   w-full"> */}
            <div className="p-8  bg-white   w-full">
                {/* <h1 className=" mt-3 font-bold  text-white text-center mb-4 bg-gradient-to-r from-[#2a627a]  bg-opacity-100 backdrop-blur-lg p-4 rounded-lg  shadow-lg transition-all duration-300"></h1> */}
                <motion.div
                    initial={{ x: -200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                    className="px-6 mb-2 text-center text-[30px] font-bold text-gray-800 bg-gradient-to-r from-[#2a627a]  bg-opacity-100 backdrop-blur-lg p-4 rounded-lg  shadow-lg transition-all duration-300"
                >
                    HikeHealth GS – Clinical Systems
                </motion.div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* Feature 1 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
                        {/* <FaRegHospital className="text-blue-500 text-3xl mb-3" /> */}
                        <h2 className="text-center font-bold">Primary Care Physicians</h2>
                        <p className="text-gray-600 text-xs mt-2">
                        We offer comprehensive healthcare solutions for primary care physicians, helping them manage patient information, treatment plans, and billing systems effectively.
                        </p>
                        <div className="-mb-12">
                            <button
                                onClick={() => navigate('/Services/ClinicalSystems/PCP')}
                                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">
                                Read More
                            </button>
                        </div>


                    </div>

                    {/* Feature 2 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
                        {/* <FaShieldAlt className="text-green-500 text-4xl mb-2" /> */}
                        <h2 className="text-lg font-bold">Hospitals & Clinics</h2>
                        <p className="text-gray-600 text-xs mt-2">
                        Supporting hospitals and clinics with software solutions that streamline emergency services, patient management, and clinical workflows for improved care delivery.
                        </p>
                        <div className="-mb-12">

                            <button onClick={() => navigate('/Services/ClinicalSystems/Hospitals&Clinics')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
                        </div>
                    </div>

                    {/* Feature 3 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
                        {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
                        <h2 className="text-lg font-bold">Specialized Care</h2>
                        <p className="text-gray-600 text-xs mt-2">
                        Providing specialized software solutions for clinical specialties like cardiology, oncology, neurology, and more, ensuring seamless integration and enhanced care.
                        </p>
                        <div className="-mb-12">

                            <button onClick={() => navigate('/Services/ClinicalSystems/SpecializedCare')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
                        </div>
                    </div>
                    {/* Feature 4 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
                        {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
                        <h2 className="text-lg font-bold">Medical Records</h2>
                        <p className="text-gray-600 text-xs mt-2">
                        We ensure secure, accurate, and compliant patient documentation through electronic health records (EHR) systems that simplify record-keeping and improve healthcare delivery.
                        </p>
                        <div className="-mb-12">

                            <button onClick={() => navigate('/Services/ClinicalSystems/MedicalRecords')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
                        </div>
                    </div>
                    {/* Feature 5 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
                        {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
                        <h2 className="text-lg font-bold">Emergency Services</h2>
                        <p className="text-gray-600 text-xs mt-2">
                        We support the development of systems for emergency care, enabling 24/7 access to critical patient data for urgent medical situations.
                        </p>
                        <div className="-mb-12">

                            <button onClick={() => navigate('/Services/ClinicalSystems/EmergencyServices')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
                        </div>
                    </div>
                    {/* Feature 6 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
                        {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
                        <h2 className="text-lg font-bold">Preventive Healthcare</h2>
                        <p className="text-gray-600 text-xs mt-2">
                        Building systems for preventive healthcare services, supporting routine checkups, wellness programs, and long-term health management for patients.
                        </p>
                        <div className="-mb-12">

                            <button onClick={() => navigate('/Services/ClinicalSystems/PreventiveHealthcare')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
                        </div>
                    </div>


                </div>


                <div><FeaturesSection /></div>
            </div>
            <Footer />
        </>
    );
};

export default HealthcareProvider;
